var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f7e972a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "p-5"
};
import { useAsync } from "@/composables/useAsync";
import { isFeatureEnabled, isNetworkAdmin, sessionState } from "@/core/session";
import { RequestStatus } from "@/features/applications/model";
import CitizenChecksBanner from "@/features/citizens/checks/CitizenChecksBanner.vue";
import ApplicationHeaderSection from "@/features/applications/ApplicationHeaderSection.vue";
import BirthRecordFormEditor from "./components/BirthRecordFormEditor.vue";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { apiBirthRecords } from "./api";
import { statusTransitions } from "./model";
import { Citizen, Feature } from "@minicity/core";
import { notifyNetworkError, notifySuccess } from "@/core/utils";
import { apiCitizens } from "@/features/citizens/api";
import { STATIC_CONFIG } from "@/core/config";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BirthRecordDetailPanel',
    props: {
        applicationId: {}
    },
    setup(__props) {
        const router = useRouter();
        const props = __props;
        const application = useAsync();
        const loadBirthRecord = () => {
            application.fetch(apiBirthRecords.getRequest(props.applicationId), "Failed to load request");
        };
        onMounted(() => {
            if (!sessionState.session)
                return; // We should only be here if we're logged-in
            loadBirthRecord();
        });
        const uploadKeyDocument = (file) => {
            return apiCitizens.uploadAttachment(application.data.citizen.id, Citizen.AttachmentType.BIRTH_RECORD, file)
                .then(doc => { application.data.keyDocumentAttachments.push(doc); });
        };
        const deleteKeyDocument = (id) => {
            return apiCitizens.deleteAttachment(application.data.citizen.id, id)
                .then(() => { application.data.keyDocumentAttachments = application.data.keyDocumentAttachments.filter((d) => d.id != id); });
        };
        const getAttachmentViewLink = (id) => {
            return apiCitizens.getAttachmentViewLink(application.data.citizen.id, id);
        };
        const sendViaVirtualMail = () => __awaiter(this, void 0, void 0, function* () {
            return apiBirthRecords.sendViaVirtualMail(props.applicationId)
                .then(() => {
                notifySuccess("Sent via mail");
                loadBirthRecord();
            })
                .catch(err => {
                notifyNetworkError("Failed to send via mail", err);
                throw err;
            });
        });
        const generateShippingLabel = () => {
            apiBirthRecords.generateShippingLabel(props.applicationId).then(downloadShippingLabel).then(loadBirthRecord);
        };
        const downloadShippingLabel = () => {
            apiBirthRecords.getShippingLabelViewLink(props.applicationId)
                .then(shippingLabelViewLink => window.open(shippingLabelViewLink));
        };
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            return (_unref(isFeatureEnabled)('BIRTH_RECORDS'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_unref(application).status == 'loading')
                        ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                        : (_unref(application).status == 'ready')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (_unref(isFeatureEnabled)(_unref(Feature).Type.EQUIFAX_CHECKS))
                                    ? (_openBlock(), _createBlock(CitizenChecksBanner, {
                                        key: 0,
                                        citizenId: _unref(application).data.citizen.id
                                    }, null, 8, ["citizenId"]))
                                    : _createCommentVNode("", true),
                                _createVNode(ApplicationHeaderSection, {
                                    underlyingApplication: _unref(application).data,
                                    submitBirthRecordByVirtualMail: _unref(application).data.status == _unref(RequestStatus).READY_TO_SUBMIT && _unref(application).data.virtualMailingEnabled && (_unref(isNetworkAdmin)() || !_unref(STATIC_CONFIG).SERVICE_ONLY_MODE) ? sendViaVirtualMail : undefined,
                                    generateShippingLabel: generateShippingLabel,
                                    downloadShippingLabel: downloadShippingLabel,
                                    applicationTypeName: "Birth Record",
                                    title: `Birth Record Request #${_unref(application).data.id}`,
                                    createdAt: _unref(application).data.createdAt,
                                    status: _unref(application).data.status,
                                    statusTransitions: _unref(statusTransitions),
                                    setStatus: _unref(application).data.isArchived ? undefined : (status) => _unref(apiBirthRecords).setStatus(_ctx.applicationId, status).then(loadBirthRecord),
                                    statusMessage: _unref(application).data.statusMessage,
                                    setStatusMessage: (message, notifyCitizen) => _unref(apiBirthRecords).setStatusMessage(_ctx.applicationId, message, notifyCitizen).then(() => _unref(application).data.statusMessage = message),
                                    deleteStatusMessage: () => _unref(apiBirthRecords).deleteStatusMessage(_ctx.applicationId).then(() => _unref(application).data.statusMessage = undefined),
                                    keyDocumentAttachments: _unref(application).data.keyDocumentAttachments,
                                    uploadKeyDocument: uploadKeyDocument,
                                    deleteKeyDocument: deleteKeyDocument,
                                    getAttachmentViewLink: getAttachmentViewLink,
                                    statusReport: _unref(application).data.statusReport,
                                    fulfillment: _unref(application).data.fulfillment,
                                    clone: () => _unref(apiBirthRecords).clone(_ctx.applicationId).then((newId) => _unref(router).push(newId)),
                                    getPdfViewLink: _unref(application).data.isArchived ? undefined : () => _unref(application).data.overriddenPdf ? _unref(apiBirthRecords).getAttachmentViewLink(_ctx.applicationId, _unref(application).data.overriddenPdf.id) : _unref(apiBirthRecords).getPdfViewLink(_ctx.applicationId),
                                    overriddenPdf: _unref(application).data.overriddenPdf,
                                    setOverriddenPdf: _unref(isNetworkAdmin)() ? (file) => _unref(apiBirthRecords).uploadOverriddenPdf(_ctx.applicationId, file).then((doc) => _unref(application).data.overriddenPdf = doc) : undefined,
                                    deleteOverriddenPdf: _unref(isNetworkAdmin)() ? () => _unref(apiBirthRecords).deleteAttachment(_ctx.applicationId, _unref(application).data.overriddenPdf.id).then(() => _unref(application).data.overriddenPdf = undefined) : undefined
                                }, null, 8, ["underlyingApplication", "submitBirthRecordByVirtualMail", "title", "createdAt", "status", "statusTransitions", "setStatus", "statusMessage", "setStatusMessage", "deleteStatusMessage", "keyDocumentAttachments", "statusReport", "fulfillment", "clone", "getPdfViewLink", "overriddenPdf", "setOverriddenPdf", "deleteOverriddenPdf"]),
                                _createVNode(BirthRecordFormEditor, {
                                    request: _unref(application).data,
                                    onChangeRequiringReload: loadBirthRecord
                                }, null, 8, ["request"])
                            ]))
                            : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
